<template>
  <div class="mini-kasko-order__group mini-kasko-order__group--wide">
    <h2 class="mini-kasko-order__group-title">Страхувальник</h2>
    <div class="mini-kasko-order__group-grid">
      <div class="mini-kasko-order__field">
        <span>ІПН / код</span>
        <div class="mini-kasko-order__client-search">
          <input
            ref="code"
            :value="value.code"
            :class="{ 'mini-kasko-order__input--invalid': Boolean(displayedCodeError) }"
            type="text"
            maxlength="10"
            inputmode="numeric"
            :readonly="isDeclared"
            @input="handleCodeInput"
            @focus="handleCodeFocus"
            @blur="handleCodeBlur"
          >
          <div
            v-if="showClientSuggestions"
            class="mini-kasko-order__client-search-dropdown"
          >
            <button
              v-for="client in clients"
              :key="client.id"
              type="button"
              class="mini-kasko-order__client-search-option"
              @mousedown.prevent="selectClient(client)"
            >
              <strong>{{ client.fio || 'Без ПІБ' }}</strong>
              <span>{{ formatClientMeta(client) }}</span>
            </button>
            <div v-if="isClientsLoading" class="mini-kasko-order__client-search-state">
              Пошук клієнтів...
            </div>
            <div
              v-else-if="showNoClientsFound"
              class="mini-kasko-order__client-search-state mini-kasko-order__client-search-state--muted"
            >
              Клієнтів не знайдено
            </div>
          </div>
        </div>
        <small v-if="displayedCodeError" class="mini-kasko-order__field-error">
          {{ displayedCodeError }}
        </small>
      </div>
      <label class="mini-kasko-order__field">
        <span>Прізвище</span>
        <input
          ref="surname"
          :value="value.surname"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.surname) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('surname', $event)"
        >
        <small v-if="errors.surname" class="mini-kasko-order__field-error">{{ errors.surname }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Ім’я</span>
        <input
          ref="name"
          :value="value.name"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.name) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('name', $event)"
        >
        <small v-if="errors.name" class="mini-kasko-order__field-error">{{ errors.name }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>По батькові</span>
        <input
          ref="middle_name"
          :value="value.middle_name"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.middle_name) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('middle_name', $event)"
        >
        <small v-if="errors.middle_name" class="mini-kasko-order__field-error">{{ errors.middle_name }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Дата народження</span>
        <input
          ref="born_date"
          :value="value.born_date"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.born_date) }"
          type="date"
          :disabled="isDeclared"
          @input="handleBirthDateInput"
        >
        <small v-if="errors.born_date" class="mini-kasko-order__field-error">{{ errors.born_date }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Паспорт</span>
        <input
          ref="document_number"
          :value="value.document_number"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.document_number) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('document_number', $event)"
        >
        <small v-if="errors.document_number" class="mini-kasko-order__field-error">{{ errors.document_number }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Дата видачі паспорта</span>
        <input
          ref="document_issued_date"
          :value="value.document_issued_date"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.document_issued_date) }"
          type="date"
          :disabled="isDeclared"
          @input="emitFieldInput('document_issued_date', $event)"
        >
        <small v-if="errors.document_issued_date" class="mini-kasko-order__field-error">{{ errors.document_issued_date }}</small>
      </label>
      <label class="mini-kasko-order__field mini-kasko-order__field--wide">
        <span>Ким видано паспорт</span>
        <input
          ref="document_issued_by"
          :value="value.document_issued_by"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.document_issued_by) }"
          type="text"
          :readonly="isDeclared"
          @input="emitFieldInput('document_issued_by', $event)"
        >
        <small v-if="errors.document_issued_by" class="mini-kasko-order__field-error">{{ errors.document_issued_by }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Телефон</span>
        <input
          ref="phone"
          :value="value.phone"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.phone) }"
          v-mask="'+38 (0##) ###-##-##'"
          type="text"
          :readonly="isDeclared"
          placeholder="+38 (0"
          @input="emitFieldInput('phone', $event)"
        >
        <small v-if="errors.phone" class="mini-kasko-order__field-error">{{ errors.phone }}</small>
      </label>
      <label class="mini-kasko-order__field">
        <span>Email</span>
        <input
          ref="email"
          :value="value.email"
          :class="{ 'mini-kasko-order__input--invalid': Boolean(errors.email) }"
          type="email"
          :readonly="isDeclared"
          @input="emitFieldInput('email', $event)"
        >
        <small v-if="errors.email" class="mini-kasko-order__field-error">{{ errors.email }}</small>
      </label>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {getData} from '@/api/client';

export default {
  name: 'MiniKaskoCustomerForm',
  props: {
    value: {
      type: Object,
      required: true,
    },
    isDeclared: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      customerCodeError: '',
      clients: [],
      isClientsLoading: false,
      isCodeFieldFocused: false,
      hasFetchedClients: false,
      fetchClientsTimeout: null,
      hideSuggestionsTimeout: null,
    };
  },
  computed: {
    displayedCodeError() {
      return this.errors.code || this.customerCodeError;
    },
    canSearchClients() {
      return !this.isDeclared && String(this.value?.code || '').replace(/\D/g, '').length >= 2;
    },
    showClientSuggestions() {
      return this.isCodeFieldFocused && this.canSearchClients && (this.isClientsLoading || this.clients.length > 0 || this.showNoClientsFound);
    },
    showNoClientsFound() {
      return this.hasFetchedClients && !this.isClientsLoading && this.clients.length === 0;
    },
  },
  watch: {
    value: {
      deep: true,
      handler(nextValue) {
        if (!nextValue?.code) {
          this.customerCodeError = '';
          return;
        }

        this.validateCustomerCode(nextValue);
      },
    },
  },
  beforeDestroy() {
    if (this.fetchClientsTimeout) {
      clearTimeout(this.fetchClientsTimeout);
    }

    if (this.hideSuggestionsTimeout) {
      clearTimeout(this.hideSuggestionsTimeout);
    }
  },
  methods: {
    buildNextValue(field, value) {
      return {
        ...this.value,
        [field]: value,
      };
    },
    resetClientSearchState() {
      this.clients = [];
      this.isClientsLoading = false;
      this.hasFetchedClients = false;

      if (this.fetchClientsTimeout) {
        clearTimeout(this.fetchClientsTimeout);
        this.fetchClientsTimeout = null;
      }
    },
    scheduleFetchClients(query) {
      if (this.fetchClientsTimeout) {
        clearTimeout(this.fetchClientsTimeout);
      }

      this.isClientsLoading = true;
      this.hasFetchedClients = false;
      this.fetchClientsTimeout = setTimeout(() => {
        this.fetchClients(query);
      }, 500);
    },
    async fetchClients(query) {
      if (!query || !this.canSearchClients) {
        this.resetClientSearchState();
        return;
      }

      const params = {
        requestType: 'clientsByUserId',
        searchText: query,
      };

      try {
        const response = await getData(params);
        this.clients = response?.data?.data?.items || [];
      } catch (error) {
        this.clients = [];
      } finally {
        this.isClientsLoading = false;
        this.hasFetchedClients = true;
        this.fetchClientsTimeout = null;
      }
    },
    handleCodeFocus() {
      this.isCodeFieldFocused = true;

      if (this.hideSuggestionsTimeout) {
        clearTimeout(this.hideSuggestionsTimeout);
        this.hideSuggestionsTimeout = null;
      }

      if (this.canSearchClients && !this.hasFetchedClients && !this.isClientsLoading) {
        this.scheduleFetchClients(String(this.value?.code || '').replace(/\D/g, ''));
      }
    },
    handleCodeBlur() {
      this.hideSuggestionsTimeout = setTimeout(() => {
        this.isCodeFieldFocused = false;
      }, 150);
    },
    formatClientMeta(client) {
      return [client.identification_number, client.date_of_birth].filter(Boolean).join(' | ');
    },
    formatClientBirthDate(date) {
      if (!date) {
        return '';
      }

      const parsedDate = moment(date, ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD.MM.YYYY'], true);

      return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : '';
    },
    getClientNameParts(client) {
      return String(client?.fio || '')
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    },
    resolveClientDocument(client) {
      const docs = client?.documents || [];
      const doc = docs.find(d => d.document_type === 3)
        || docs.find(d => d.document_type === 1)
        || null;
      if (!doc) return {};
      const serial = doc.serial ? String(doc.serial).trim() : '';
      const number = doc.number ? String(doc.number).trim() : '';
      return {
        document_number: (serial && number && doc.document_type === 1) ? serial + number : number,
        document_issued_by: doc.issued_by ? String(doc.issued_by).trim() : '',
        document_issued_date: doc.date_of_issue
          ? moment(doc.date_of_issue, ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD.MM.YYYY'], true).isValid()
            ? moment(doc.date_of_issue, ['DD-MM-YYYY', 'YYYY-MM-DD', 'DD.MM.YYYY'], true).format('YYYY-MM-DD')
            : doc.date_of_issue.slice(0, 10)
          : '',
      };
    },
    selectClient(client) {
      const [surname = '', name = '', middleName = ''] = this.getClientNameParts(client);
      const doc = this.resolveClientDocument(client);
      const nextValue = {
        ...this.value,
        code: client?.identification_number || this.value.code || '',
        surname: surname || this.value.surname || '',
        name: name || this.value.name || '',
        middle_name: middleName || this.value.middle_name || '',
        phone: client?.phone || this.value.phone || '',
        email: client?.email || this.value.email || '',
        document_number: doc.document_number || this.value.document_number || '',
        document_issued_by: doc.document_issued_by || this.value.document_issued_by || '',
        document_issued_date: doc.document_issued_date || this.value.document_issued_date || '',
        born_date: this.formatClientBirthDate(client?.date_of_birth) || this.value.born_date || '',
        city_id: client?.city?.id || this.value.city_id || null,
        city_name: client?.city?.name_full_name_ua || this.value.city_name || '',
        street: client?.street ? String(client.street).trim() : this.value.street || '',
        house: client?.house || this.value.house || '',
        apartment: client?.flat || this.value.apartment || '',
      };

      this.$emit('input', nextValue);
      [
        'code',
        'surname',
        'name',
        'middle_name',
        'phone',
        'email',
        'document_number',
        'document_issued_by',
        'document_issued_date',
        'born_date',
        'city_id',
        'street',
        'house',
        'apartment',
      ].forEach((field) => {
        this.$emit('field-change', field);
      });

      this.validateCustomerCode(nextValue);
      this.resetClientSearchState();
      this.isCodeFieldFocused = false;
    },
    getCustomerBirthDateFromCode(code) {
      if (!/^\d{10}$/.test(code)) {
        return null;
      }

      const date = moment('1900-01-01', 'YYYY-MM-DD')
        .add(Number(code.slice(0, 5)) - 1, 'days');

      if (!date.isValid()) {
        return null;
      }

      return date;
    },
    isValidCustomerCodeChecksum(code) {
      if (!/^\d{10}$/.test(code)) {
        return false;
      }

      const digits = code.split('').map(Number);
      const checksum = (
        digits[0] * -1 +
        digits[1] * 5 +
        digits[2] * 7 +
        digits[3] * 9 +
        digits[4] * 4 +
        digits[5] * 6 +
        digits[6] * 10 +
        digits[7] * 5 +
        digits[8] * 7
      ) % 11;
      const normalizedChecksum = checksum < 0 ? checksum + 11 : checksum;
      const controlDigit = normalizedChecksum === 10 ? 0 : normalizedChecksum;

      return controlDigit === digits[9];
    },
    validateCustomerCode(customer = this.value) {
      const code = customer?.code;

      if (!code) {
        this.customerCodeError = '';
        return true;
      }

      if (!/^\d{10}$/.test(code)) {
        this.customerCodeError = 'ІПН повинен містити 10 цифр.';
        return false;
      }

      const birthDate = this.getCustomerBirthDateFromCode(code);
      if (!birthDate || birthDate.isAfter(moment())) {
        this.customerCodeError = 'Некоректний ІПН.';
        return false;
      }

      if (!this.isValidCustomerCodeChecksum(code)) {
        this.customerCodeError = 'Некоректний ІПН.';
        return false;
      }

      if (customer?.born_date && customer.born_date !== birthDate.format('YYYY-MM-DD')) {
        this.customerCodeError = 'ІПН та дата народження не співпадають.';
        return false;
      }

      this.customerCodeError = '';
      return true;
    },
    emitFieldInput(field, event) {
      const value = String(event?.target?.value || '').trim();

      this.$emit('input', this.buildNextValue(field, value));
      this.$emit('field-change', field);
    },
    handleCodeInput(event) {
      const value = String(event?.target?.value || '').replace(/\D/g, '').slice(0, 10);
      const nextValue = this.buildNextValue('code', value);

      if (!value) {
        this.customerCodeError = '';
        nextValue.born_date = '';
        nextValue.surname = this.value.surname || '';
        nextValue.name = this.value.name || '';
        nextValue.middle_name = this.value.middle_name || '';
        this.$emit('input', nextValue);
        this.$emit('field-change', 'code');
        this.$emit('field-change', 'born_date');
        this.resetClientSearchState();
        return;
      }

      const birthDate = this.getCustomerBirthDateFromCode(value);

      if (value.length === 10 && birthDate && !birthDate.isAfter(moment())) {
        nextValue.born_date = birthDate.format('YYYY-MM-DD');
        this.$emit('field-change', 'born_date');
      }

      this.$emit('input', nextValue);
      this.$emit('field-change', 'code');
      this.validateCustomerCode(nextValue);

      if (value.length >= 2) {
        this.scheduleFetchClients(value);
      } else {
        this.resetClientSearchState();
      }
    },
    handleBirthDateInput(event) {
      const value = event?.target?.value || '';
      const nextValue = this.buildNextValue('born_date', value);

      this.$emit('input', nextValue);
      this.$emit('field-change', 'born_date');
      this.validateCustomerCode(nextValue);
    },
    focus(field) {
      const input = this.$refs[field];

      if (!input) {
        return false;
      }

      if (typeof input.scrollIntoView === 'function') {
        input.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }

      if (typeof input.focus === 'function') {
        try {
          input.focus({
            preventScroll: true,
          });
        } catch (error) {
          input.focus();
        }
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-order {
  &__group {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &--wide {
      grid-column: span 2;
    }
  }

  &__group-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__group-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }

    &__field {
      display: flex;
      flex-direction: column;
      gap: 6px;

    span {
      font-size: 13px;
      line-height: 18px;
      color: #52525b;
    }

    input {
      width: 100%;
      min-height: 44px;
      padding: 10px 12px;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      background: #fff;
      outline: none;
      transition: border-color 0.2s ease, box-shadow 0.2s ease;

      &:focus {
        border-color: #fb923c;
        box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.15);
      }

      &[readonly],
      &:disabled {
        background: #f8fafc;
        color: #52525b;
        cursor: default;
      }
    }

    .mini-kasko-order__input--invalid {
      border-color: #ef4444;

      &:focus {
        border-color: #ef4444;
        box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
      }
    }
  }

  &__client-search {
    position: relative;
  }

  &__client-search-dropdown {
    position: absolute;
    z-index: 20;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  }

  &__client-search-option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    width: 100%;
    padding: 10px 12px;
    border: 0;
    border-radius: 8px;
    background: #fff;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;

    strong {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      color: #0f172a;
    }

    span {
      font-size: 12px;
      line-height: 16px;
      color: #64748b;
    }

    &:hover,
    &:focus {
      background: #fff7ed;
      outline: none;
    }
  }

  &__client-search-state {
    padding: 10px 12px;
    font-size: 13px;
    line-height: 18px;
    color: #0f172a;

    &--muted {
      color: #64748b;
    }
  }

  &__field-error {
    color: #dc2626;
    font-size: 12px;
    line-height: 16px;
  }

  @media (max-width: 960px) {
    &__group-grid {
      grid-template-columns: 1fr;
    }

    &__group--wide {
      grid-column: span 1;
    }
  }
}
</style>
